import { Interpolation } from "@emotion/core";
import { grid } from "../../../../design-tokens/grid";
import { Fonts } from "../../../../design-tokens/fonts";

const root: Interpolation = {
  marginBottom: grid(4),
};

const barContainer: Interpolation = {
  display: "flex",
  marginBottom: grid(1),

  "> div": {
    height: grid(2),
    borderRadius: grid(2),

    ":not(:last-child)": {
      marginRight: grid(1),
    },
  },
};

const labelContainer: Interpolation = {
  display: "flex",
  marginBottom: grid(1),

  "> div": {
    ":not(:last-child)": {
      marginRight: grid(1.5),
    },
  },
};

const label: Interpolation = {
  fontSize: 14,
  fontWeight: Fonts.Weight.Bold,
};

const percent: Interpolation = {
  display: "flex",
  alignItems: "center",
  fontSize: 14,
  whiteSpace: "nowrap",
};

const indicator: Interpolation = {
  width: 10,
  height: 10,
  marginRight: grid(1),
  borderRadius: "50%",
};

const styles = {
  root,
  barContainer,
  labelContainer,
  label,
  percent,
  indicator,
};

export default styles;
